/**
 * Product feature flags.
 *
 * CRA inlines REACT_APP_* at build time — restart the app after changing env.
 * Keep flags off by default so production is unchanged until we opt in.
 */
export const FEATURE_FLAGS = {
  /**
   * Peg Board session type. Off by default.
   * Enable locally with REACT_APP_ENABLE_PEG_BOARD=true
   */
  pegBoard: process.env.REACT_APP_ENABLE_PEG_BOARD === 'true',
};

export const isPegBoardEnabled = () => FEATURE_FLAGS.pegBoard === true;
